import { Bean, BindingCreator } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../translations';

const t = visitSettlementTranslationKeys.shared.priceChangeReason.field;

type PriceChangeReasonFieldProps = {
   readonly register: BindingCreator<Bean, any>;
   readonly name: 'visitSettlement.priceChangeReason' | 'priceChangeReason';
};

export const PriceChangeReasonField = (props: PriceChangeReasonFieldProps): JSX.Element => {
   return (
      <Textarea
         rows={6}
         maxRows={6}
         placeholder={t.placeholder}
         label={t.label}
         controller={props.register(props.name)}
         maxLength={500}
         testId={'priceChangeReason'}
      />
   );
};
